/**
 * Created by wuyanbin on 2019/5/27
 */
import { __awaiter } from "tslib";
/**
 * 发起争议处理
 */
import { createStore } from '@souche-f2e/muji';
import Api from '@/services';
export default createStore({
    state: {
        callback: null,
        confirmLoading: false,
        isShow: false,
        orderId: '',
        contractLinkImg: [],
        contractLinkPdf: '',
    },
    effects: {
        getContractInfo(payload, { state }) {
            Api.order.querySignedContract({ orderId: state.orderId }).then((res) => {
                if (res) {
                    this.SET_STATE({
                        contractLinkImg: res.contractLinkImg,
                        contractLinkPdf: res.contractLinkPdf,
                        isShow: true,
                    });
                    this.getContractToIFrame({});
                }
                state.callback && state.callback();
            });
        },
        showModal(payload, { state }) {
            return __awaiter(this, void 0, void 0, function* () {
                yield this.show(payload);
            });
        },
        // 提前将合同图片存入iframe chrome兼容性
        getContractToIFrame() {
            const content = document.getElementById('print__html');
            const pri = document.getElementById('ifmcontentstoprint').contentWindow;
            pri.document.open();
            pri.document.write(content.innerHTML);
            pri.document.close();
        },
    },
    reducers: {
        SET_STATE(state, payload) {
            Object.keys(payload).forEach((key) => {
                if (typeof payload[key] !== 'undefined') {
                    state[key] = payload[key];
                }
            });
        },
        show(state, payload) {
            if (payload && payload.orderId) {
                state.orderId = payload.orderId;
                state.callback = payload.callback;
                // state.isShow = true;
            }
            else {
                console.warn('发起争议组件必需参数orderId 请检查是否传入！');
            }
        },
        hide(state) {
            state.isShow = false;
            state.orderId = null;
            state.callback = null;
            state.contractLinkImg = [];
            state.contractLinkPdf = '';
        },
    },
});
